/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Self_Organize_Seat_BtnInputs */



/**
* | output |
* | --- |
* | "Start round" |
*
* @param {Self_Organize_Seat_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_seat_btn = /** @type {((inputs?: Self_Organize_Seat_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_Seat_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencer la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Iniciar rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia round")
	return /** @type {LocalizedString} */ ("Start round")
});